import type { ReactNode } from "react";
import type { BoxProps, SvgIconProps } from "@mui/material";
import { Box } from "@mui/material";
import type { StatutAssociation } from "constants/SatutMap";

interface CommandeStatutIconProps {
  boxProps?: Omit<BoxProps, "sx">;
  svgIconProps?: SvgIconProps;
  statutAssociation?: StatutAssociation;
}

function CommandeStatutIcon({
  boxProps,
  svgIconProps,
  statutAssociation,
}: Readonly<CommandeStatutIconProps>): ReactNode {
  if (statutAssociation == null) {
    return null;
  }

  return (
    <Box
      sx={{
        display: "flex",
        width: 32,
        height: 32,
        backgroundColor: `${statutAssociation.color}.main`,
        borderRadius: "5px",
        alignItems: "center",
        justifyContent: "center",
      }}
      {...boxProps}>
      <statutAssociation.icon
        viewBox="0 0 24 24"
        sx={{ color: "white" }}
        fontSize="small"
        {...svgIconProps}
      />
    </Box>
  );
}

export default CommandeStatutIcon;
